export function hookBuyItNow() {
  // Hook buy it now
  const originalFetch = window.fetch;
  window.fetch = async (url, args) => {
    if (url === '/wallets/checkouts.json' && args.method === 'POST') {
      try {
        // Get selected items
        const selectedItemsObj = window.upsellGetSelectedAddons();

        // Parse from JSON
        const body = JSON.parse(args.body);
        const lineItems = body.checkout.line_items;

        for (const variantId in selectedItemsObj) {
          lineItems.push({
            variant_id: variantId,
            quantity: selectedItemsObj[variantId]
          });
        }

        body.checkout.line_items = lineItems;

        // Convert to JSON
        args.body = JSON.stringify(body);
      } catch (e) {
        console.log('err', e);
      }
    }

    return await originalFetch(url, args);
  }
}
